import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs/internal/observable/throwError';
import {ErrorHandler} from './ErrorHandler';
import {AuthserviceService} from '../content/pages-new-design/auth-page/login-page/authservice.service';
import {TranslateService} from '@ngx-translate/core';
import {CompoApp} from '../services/CompoApp';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {Observable} from 'rxjs/internal/Observable';
import ErrorCode from "../enums/ErrorCode";
import { MessageDesignBUtils } from '../content/components/message-design-b/message-design-b.utils';
import { GlobalMessageClientService } from '../services/client/global-message-client-service/global-message-client.service';
import { of } from 'rxjs';
import { CompogeniusNavi } from '../services/client/navigation-service/base-routes-navigation-client.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  protected messageClientService = inject(GlobalMessageClientService);

  constructor(private authService: AuthserviceService,
              private translate: TranslateService,
              private messageService: MessageService,
              private app: CompoApp,
              private router: Router) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        // Try one more to call the api
        catchError((error: HttpErrorResponse) => {

          const urlString = error?.url.toString();

          const isClassImageRequest = urlString.includes('/rest/classImage/');
          const isChunkRequest = urlString.includes('/rest/chunk/');

          if (isChunkRequest || isClassImageRequest) {
            // ignore for now
            return throwError(error);
          }

          // if (error.status == null) {
          //   this.app.on.serverUnreachable$.next(true);
          //   this.messageClientService.clear();
          //   this.messageClientService.messages$.next(MessageDesignBUtils.cannotReachServer());
          //   return;
          // }

          if (error.status === 0) {
            this.app.on.serverUnreachable$.next(true);
            this.messageService.clear();
            this.messageClientService.messages$.next(MessageDesignBUtils.cannotReachServer());
            setTimeout(() => {
              this.authService.refreshToken();
            }, 1000);
            return throwError(error);
          }

          if ((error.status === 401) && error.url.toString().substr(error.url.length - 5) === 'auth/'
            || ((error.status === 400) && error.error.errorCode === ErrorCode.CAN_NOT_RESET_PASSWORD_TO_EXISTING_ONE)
          ) {
            return throwError(error);
          }
          if ((error.status === 401) && error.url.toString().substr(error.url.length - 5) !== 'auth/') {
            this.messageService.clear();
            this.app.data.clear();
            this.router.navigate(['/']);
            return throwError(error);
          }
          if (error.status === 400 && error.error.errorName) {
            this.messageService.clear();
            // this.router.navigateByUrl('home/error?errorName=' + error.error.errorName);
          }
          if (error.status === 400 && error.error.errorCode === ErrorCode.EMAIL_ALREADY_ASSIGNED) {
            // is handled in 'cp-organization-create-dialog-b'
            return throwError(error);
          }
          if (error.status === 400 && error.error.errorCode === ErrorCode.CHECKLIST_REVISION_NOT_MODIFIABLE) {
            // handled in checklist fill out page
            return throwError(error);
          }
          if (error.status === 400 && error.error.errorCode === ErrorCode.CHECKLIST_TEMPLATE_VERSION_INVALID_SHARE_CODE) {
            // handled in create-checklist-template-dialog
            return throwError(error);
          }
          if (error.status === 400 && error.error.errorCode === ErrorCode.OBJECT_VALIDATION_CLASS_NOT_IN_PRIO_CLASS) {
            // handled in
            const errorHandler = new ErrorHandler(this.translate);
            const msg = errorHandler.createErrorMessage(error);
            this.app.on.errorAndWarningMessagesInHeader$.next(MessageDesignBUtils.exceptionMessage(msg));
            return throwError(error);
          }
          if (error.status === 400 && error.error.errorCode === ErrorCode.JOB_COORDINATION_NOT_FOUND) {
            this.router.navigate([CompogeniusNavi.singletonInstance().home.process.jobs.url]);
            return of();
          }
          if (error.status === 404) {
            this.messageService.clear();
            this.router.navigate(['home/error']);
          }
          //for now - until we figure out why this error happens
          //we will catch it
          if ((error.status === 502) && error.statusText.toLowerCase() == "proxy error") {
            return throwError(error);
          }

          if (error.error?.orchestrationError === true) {
            return throwError(error);
          }
          // Other Error Cases
          const errorHandler = new ErrorHandler(this.translate);
          const msg = errorHandler.createErrorMessage(error);

          this.app.on.errorAndWarningMessagesInHeader$.next(
            MessageDesignBUtils.exceptionMessage(msg)
          );

          return throwError(error);
        })
      );
  }

}
